import APIClient from './client'
import { camelizeKeys, decamelizeKeys } from 'humps'

// The keys inside an agency's `properties` map are property names — user data such as
// `lead_source` — and must round-trip verbatim. The map is lifted out before humps runs
// on the agency's own keys and reattached by reference, never rebuilt.
const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

const camelizeAgency = (agency) => {
  if (!isPlainObject(agency)) return camelizeKeys(agency)

  const { properties, ...rest } = agency
  const camelized = camelizeKeys(rest)
  if ('properties' in agency) camelized.properties = properties
  return camelized
}

const decamelizeAgency = (payload) => {
  if (!isPlainObject(payload)) return decamelizeKeys(payload)

  const { properties, ...rest } = payload
  const decamelized = decamelizeKeys(rest)
  if (properties !== undefined) decamelized.properties = properties
  return decamelized
}

// The body is serialised here rather than left to axios: axios deep-copies an object body and
// drops own keys named `constructor`, `__proto__` and `prototype`, all valid property names.
const agencyBody = (payload) => JSON.stringify({ agency: decamelizeAgency(payload) })

const getAllAgenciesUnderBrand = ( brandId ) => {
  return APIClient().get(`/v1/brands/${brandId}/agencies`)
    .then( response => Array.isArray(response.data) ? response.data.map(camelizeAgency) : camelizeKeys(response.data))
}

const getAgency = ( agencyId ) => {
  return APIClient().get(`/v1/agencies/${agencyId}`)
    .then( response => camelizeAgency(response.data))
}

const createNewAgency = ({ brandId, payload }) => {
  return APIClient().post(`/v1/brands/${brandId}/agencies`, agencyBody(payload))
    .then( response => camelizeAgency(response.data))
}

const updateExistingAgency = ({ agencyId, payload }) => {
  return APIClient().put(`/v1/agencies/${agencyId}`, agencyBody(payload))
    .then( response => camelizeAgency(response.data))
}

const AgenciesAPI = {
  getAgency,
  getAllAgenciesUnderBrand,
  createNewAgency,
  updateExistingAgency
}

export default AgenciesAPI
